import { Group, Anchor, Divider, Button, Container, Image, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { UserDropdown } from './UserDropdown';
import headerLogoDark from '../assets/header_logo_dark.png';

export const TopNavigation = () => {
  const navigate = useNavigate();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  return (
    <Container 
      fluid 
      style={{ 
        paddingRight: 'var(--mantine-spacing-xs)', 
        height: '100%',
        backgroundColor: '#228be6',
      }}
    >
      <Group justify="space-between" align="center" h="100%">
        <Group gap="sm" align="center">
          <Anchor onClick={() => navigate('/')} style={{ textDecoration: 'none' }}>
            <Image
              src={headerLogoDark}
              alt="Sandbox Studio"
              style={{
                objectFit: 'contain',
                maxWidth: '156px',
                maxHeight: '28px',
                marginLeft: '8px',
              }}
            />
          </Anchor>
        </Group>

        <Group gap="sm" align="center">
          <Button
            variant="subtle"
            onClick={() => toggleColorScheme()}
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              padding: 'var(--mantine-spacing-xs)',
              width: '36px',
              height: '36px',
            }}
          >
            {colorScheme === 'dark' ? <IconSun size={22} color="white" /> : <IconMoon size={22} color="white" />}
          </Button>

          <Divider
            orientation="vertical"
            style={{
              borderColor: 'rgba(255, 255, 255, 0.3)',
              height: '30px',
              marginBlock: '3px',
            }}
          />

          <UserDropdown />
        </Group>
      </Group>
    </Container>
  );
};
